"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const PadelLoading_1 = require("./PadelLoading");
const LoadingScreen = () => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "w-screen h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-slate-200", children: (0, jsx_runtime_1.jsx)(PadelLoading_1.PadelLoading, {}) }));
};
exports.LoadingScreen = LoadingScreen;
